
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/pickup/ford-ranger",
      function () {
        return require("private-next-pages/wheels/pickup/ford-ranger.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/pickup/ford-ranger"])
      });
    }
  